module.exports = __webpack_public_path__ + "img/feedback-down.bacf3136.png";